import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./dialog";
import { Button } from "./button";
import { listFilesInFirebase } from "@/lib/firebase/mediaUploading";

type MediaLibraryDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  refPath: string; // folder to browse
  onSelect: (url: string) => void; // return the selected file URL
  title?: string;
  description?: string;
};

export function MediaLibraryDialog({ open, onOpenChange, refPath, onSelect, title = "Select from Library", description = "Choose an image from existing uploads" }: MediaLibraryDialogProps) {
  const [loading, setLoading] = React.useState(false);
  const [items, setItems] = React.useState<Array<{ name: string; url: string }>>([]);

  React.useEffect(() => {
    if (!open) return;
    setLoading(true);
    listFilesInFirebase(refPath)
      .then((files) => setItems(files))
      .finally(() => setLoading(false));
  }, [open, refPath]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description ? <DialogDescription>{description}</DialogDescription> : null}
        </DialogHeader>
        <div className="min-h-[200px]">
          {loading ? (
            <div className="text-sm text-muted-foreground">Loading…</div>
          ) : items.length === 0 ? (
            <div className="text-sm text-muted-foreground">No media found in this folder.</div>
          ) : (
            <div className="grid grid-cols-3 gap-3">
              {items.map((item) => (
                <button
                  key={item.url}
                  type="button"
                  onClick={() => onSelect(item.url)}
                  className="border rounded-md overflow-hidden hover:ring-2 hover:ring-primary"
                >
                  <img src={item.url} alt={item.name} className="w-full h-32 object-cover" />
                </button>
              ))}
            </div>
          )}
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default MediaLibraryDialog;
